module.exports = "/_next/static/images/Electrical-3ce6dd447b7fa2b4dd872dd184f87602.png";